import { render, staticRenderFns } from "./table-column.vue?vue&type=template&id=52aae4f0"
import script from "./table-column.vue?vue&type=script&lang=js"
export * from "./table-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports